export default function ForageLogo({ size = 32, color = "currentColor" }){
  return(
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Leaf outline */}
      <path
        d="M12 21C12 21 4 16 4 10C4 6.1 7.6 3 12 3C16.4 3 20 6.1 20 10C20 16 12 21 12 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Centre vein */}
      <path
        d="M12 21V9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Left side vein */}
      <path
        d="M12 15L8 12"
        stroke={color}
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      {/* Right side vein */}
      <path
        d="M12 15L16 12"
        stroke={color}
        strokeWidth="1.1"
        strokeLinecap="round"
      />
    </svg>
  );
}
